import { Deserializable } from '../../protocols/deserializable';

export class SmallPensionMonthlyLimit implements Deserializable {
  public id!: number;
  public year!: number;
  public limitAmount!: number;

  public onDeserialize(): void {}
}
